import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import TableContainerMin from "../../../../common/TableContainerMin";
import { Button, Card } from "reactstrap";
import filter from "../../../../assets/images/cuida_filter-outline.png";
import { getBusinessMarchandById } from "../services/merchentApi";
import defaultAvatar from "../../../../assets/images/image business défaut.png";
import { Spin } from "antd";
import { FormatCurrency } from "../../../../common/format/formatCurrency";
import { useQuery, useQueryClient } from "react-query";
import { getPaymentMethods } from "../../../transactions/services/transactionApi";
import CreationBusiness from "./creation-business/creation-business";
import FiltrerBusinessModal from "./FiltrerBusinessModal";
const BusinessByMarchand = ({id}) => {
    const navigate = useNavigate();
     const [searchTerm, setSearchTerm] = useState("");
     const [modalState, setModalState] = useState({ type: null, data: null });
   const [filterValues, setFilterValues] = useState({
  isActive: null,
  country: "",
  requestDateFrom: "",
  requestDateTo: "",
  approvalDateFrom: "",
  approvalDateTo: "",
  sort: "desc",
});
      const [merchantBusiness, setBusinessMerchant] = useState(null);
const filteredBusiness = merchantBusiness?.filter((business) => {
  let match = true;
 if (searchTerm) {
  const search = searchTerm.toLowerCase();

  match =
    match &&
    (
      business.businessName?.toLowerCase().includes(search) ||
      business.country?.toLowerCase().includes(search)
    );
}

  // STATUS
  if (filterValues?.isActive !== null) {
    match = match && business.isActive === filterValues.isActive;
  }

  // COUNTRY
  if (filterValues?.country) {
    match = match && business.country === filterValues.country;
  }

  // REQUEST DATE RANGE
  if (filterValues?.requestDateFrom) {
    match =
      match &&
      new Date(business.requestDate) >= new Date(filterValues.requestDateFrom);
  }

  if (filterValues?.requestDateTo) {
    match =
      match &&
      new Date(business.requestDate) <= new Date(filterValues.requestDateTo);
  }

  // APPROVAL DATE RANGE
  if (filterValues?.approvalDateFrom) {
    match =
      match &&
      new Date(business.approvalDate) >= new Date(filterValues.approvalDateFrom);
  }

  if (filterValues?.approvalDateTo) {
    match =
      match &&
      new Date(business.approvalDate) <= new Date(filterValues.approvalDateTo);
  }

  return match;
});
 const handleApplyFilters = (filters) => {
      setFilterValues(filters);
      closeModal();
    };
    const currentuser = JSON.parse(sessionStorage.getItem("authAdmin"));
 const handleDetail = (merchantBusiness) => {
  if (!merchantBusiness || !merchantBusiness.id) {
    console.warn("Developer invalide :",merchantBusiness);
    return;
  }
  navigate(`/business-management/${merchantBusiness.id}`);
};
const [loading, setLoading] = useState(false);
useEffect(() => {
  const fetchBusinessMerchant = async () => {
    setLoading(true); 
    try {
      const dat = await getBusinessMarchandById(id);
      setBusinessMerchant(dat);
    } catch (error) {
      console.error("Erreur lors du chargement du business du marchand :", error);
    }
    finally {
      setLoading(false); 
    }
  };

  if (id) {
    fetchBusinessMerchant();
  }
}, [id]);
const openModal = (type, data = null) => {
  setModalState({ type, data });
};

const closeModal = () => {
  setModalState({ type: null, data: null });
};
const itemsPerPage = 10;
const [currentPage, setCurrentPage] = useState(1);
const totalPages = Math.ceil(filteredBusiness?.length / itemsPerPage);
const [showAll, setShowAll] = useState(false);
const visibleBusinesses = showAll
  ? filteredBusiness
  : filteredBusiness?.slice(0, 4);
const paginatedBusinesses = filteredBusiness?.slice(
  (currentPage - 1) * itemsPerPage,
  currentPage * itemsPerPage
);
  const { data, isLoading: isLoadingPaym, isError: isErrorPaym, error: errorPaym } = useQuery(
    "paymentList", getPaymentMethods
  );
   const paymentList = Array.isArray(data?.data) ? data.data : [];
   const handleAddBusiness = (newBusiness) => {
  setBusinessMerchant((prev) => [newBusiness, ...(prev || [])]);
};
return(
<>
<Card  style={{ padding: "12px" }}>
      <div style={{
            margin: "0 auto",
            padding: "0 20px",
            gap: "10px",
            }}
            >
              <div className="business-header">
                <div className="title-detail-business">
                  Business du marchand
                </div>

                <button className="buttonNewColla btn btn-primary"  onClick={() => openModal("create")}>
                  + Nouveau business
                </button>
              </div>
                <div className="sous-title-detail-business mb-3">Liste des business associés à ce marchand</div>
                <div className="business-toolbar">
                <input
                  type="text"
                  placeholder="Recherche un business..."
                  className="form-control"
                  style={{ width: "100%" }}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  value={searchTerm}
                />
                <Button
                  className="filtrer"
                  onClick={() => openModal("business-filtrer")}
                  style={{ display: "flex", alignItems: "center", gap: "8px" }}
                >
                  <img src={filter} alt="Filtrer" width={20} />
                  Filtrer
                </Button>
                <Button
                  className="filtrer"
                  onClick={() => openModal("business-trier")}
                  style={{ display: "flex", alignItems: "center", gap: "8px" }}
                >
                  <img src={filter} alt="Trier" width={20} />
                  Trier
                </Button>
              </div>
              <div className="row g-3">
                {loading ? (
                  <div className="text-center p-4">
                    <Spin />
                  </div>
                ) : visibleBusinesses && visibleBusinesses.length > 0 ? (
                  visibleBusinesses.map((business, index) => (
                <div
                  key={index}
                  className={
                    visibleBusinesses.length === 1
                      ? "col-12"
                      : "col-12 col-md-6"
                  }
                > 
                <Card className="card-business" style={{
                padding: "12px",
                cursor: "pointer",
                transition: "0.2s",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "scale(1.02)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "scale(1)";
              }}
              onClick={() => handleDetail(business)}>
              <div className="d-flex justify-content-between align-items-center">

            <div className="d-flex align-items-center gap-2">
              <img
                src={ business?.logo ||defaultAvatar}
                alt=""
                style={{
                  width: 28,
                  height: 28,
                  borderRadius: "50%"
                }}
              />
              <span className="name-business">
                {business.businessName}
              </span>
            </div>
            <span
              style={{
                backgroundColor:
                  business.isActive ? "#EBFFEA" : "#FFF0F0",
                color: business.isActive ? "#349C32" : "#D41C1C",
                padding: "3px 8px",
                borderRadius: "100px",
                fontSize: "13px"
              }}
            >
              {business.isActive ? "✓ Actif" : "✗ Inactif"}
            </span>
          </div>
          <div className="sous-title-detail-business" style={{ marginTop: "6px" }}>
            {business.country} • {business.environmentMod}
          </div>

          <hr style={{ margin: "10px 0" }} />

          {/* INFOS */}
  <div className="d-flex flex-column gap-2">
  <div className="business-stats">
  <div style={{ flex: 1, paddingRight: "10px", borderRight: "1px solid #E3E3E3" }}>
    <div className="d-flex justify-content-between">
      <span className="sous-title-detail-business">Montant encaissé</span>
      <span className="info-business">
        {FormatCurrency(business.balance || 0)}
      </span>
    </div>
    <div className="d-flex justify-content-between">
      <span className="sous-title-detail-business">Transactions</span>
      <span className="info-business">
        {business.totalTransactions?.toLocaleString() || 0}
      </span>
    </div>
  </div>
  <div style={{ flex: 1, paddingLeft: "10px" }}>
    <div className="d-flex justify-content-between">
      <span className="sous-title-detail-business">Solde Disponible</span>
      <span className="info-business"style={{color:'#349C32'}}>
        {FormatCurrency(business.availableAmount || 0)}
      </span>
    </div>
    <div className="d-flex justify-content-between">
      <span className="sous-title-detail-business">Total montant gelé</span>
      <span className="info-business"style={{color:'#396AFC'}}>
        {FormatCurrency(business.frozenBalance || 0)}
      </span>
    </div>
  </div>
</div>
</div>
</Card>
</div>
))
  ) : (
    <div className="text-center p-4">
      📭 Aucun business trouvé
    </div>
  )}
  {filteredBusiness?.length > 4 && (
  <div className="text-center mt-3">
    <Button
      onClick={() => setShowAll(!showAll)}
      className="filtrer"
    >
      {showAll ? "Voir moins" : "Voir plus"}
    </Button>
  </div>
)}
</div>
</div>
 {modalState.type === "business-filtrer" && (
    <FiltrerBusinessModal
    isOpen={modalState.type === "business-filtrer"}
   toggle={closeModal}
   onApply={handleApplyFilters}      
  />
  )}
 <CreationBusiness
  modal={modalState.type === "create"}
  setModal={setModalState}
 toggle={closeModal}
  selectedDeveloper={modalState.data}
  currentuser={currentuser}
  merchantId={id}
  paymentList={paymentList}
  isLoadingPaym={isLoadingPaym}
  isErrorPaym={isErrorPaym}
  errorPaym={errorPaym}
  onSuccess={handleAddBusiness}
/>
</Card>
  </>
);
}
export default BusinessByMarchand;